import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Typography } from '@mui/material';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);



const ChartLine = (props) => {
    const { data } = props


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: data?.legend,
                position: "bottom",

            },
            title: {
                display: true,
                text: data.unit,
                position: "left"
            },
            tooltip: {
                enabled: true,
                usePointStyle: true,
                callbacks: {
                    title: (datas) => {
                        return datas[0].dataset.label
                    },
                    label: (datas) => {
                        let percentage = (data.percentage) ? '%' : '';
                        let value = (datas.raw % 1 !== 0) ? Number(datas.raw).toFixed(2) : datas.raw;
                        return ` ${datas.label} ${value} ${percentage}`
                    }
                },
            }
        }
    };

    return (
        <>
            <div className="title_chart">
                <Typography className="content-text" variant="h6" style={{ fontSize: '1.15rem' }}>
                    {data.title}
                </Typography>
                <Typography className="content-text" style={{ fontSize: '0.9 rem' }}>
                    {data.subTitle}
                </Typography>
            </div>
            <div className="body_chart">
                {
                    data?.data &&
                    <Line data={data} options={options} />
                }
            </div>
        </>
    )
}

export default ChartLine